<template>
  <div>
    <!-- Modal de MDB Vue -->
    <MDBModal v-model="modalVisible" >
      <MDBModalDialog :class="{ 'less-margin': form, '': !form }">
        <MDBModalHeader class="font-raleway-Light-20">
          {{ dynamicTitle }}
        </MDBModalHeader>
        <CreateFormComponent v-if="form" ref="createFormRef"/>
          <MDBModalBody>
            <p class="font-roboto-regular-18 text-center" v-if="!form">{{ dynamicContent }}</p> 
          </MDBModalBody>
          <MDBModalFooter>
            <button type="button" class="btn btn-outline-success" v-if="form" @click="submitForm">Crear Flota</button>
            <MDBBtn color="secondary" v-if="!form" @click="closeModal">Cerrar</MDBBtn>
          </MDBModalFooter>
      </MDBModalDialog>
    </MDBModal>

    <MDBModal v-model="showSecondModal">
      <MDBModalDialog>
        <MDBModalHeader class="font-raleway-Light-20">
          {{ dynamicTitle2 }}
        </MDBModalHeader>
        <MDBModalBody>
          <div class="font-roboto-regular-18 text-center">
            <div class="text-center">
              <div class="mb-3">Empresa: {{enterpriseName }}</div>
              <div class="mb-3 me-4 pe-2">Usuario: admin
              </div>
              <div>Contraseña: {{pwd}}</div>
            </div>
          </div>
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="secondary" @click="closeSecondModal">Cerrar</MDBBtn>
        </MDBModalFooter>
      </MDBModalDialog>
    </MDBModal>
  </div>
</template>

<script>

export default {
  name: 'ModalComponent',
  data() {
    return {
      modalVisible: false,
      showSecondModal: false,
      dynamicTitle : '',
      dynamicTitle2 : '',
      enterpriseName: '',
      pwd: '',
      form: false,
      result: undefined,
      json : [],
    };
  },
  methods: {
    openModal() {
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
    submitForm() {
      
      const user = localStorage.getItem('user');
      const pass = localStorage.getItem('pass');
      const data = localStorage.getItem('data');
      this.json = JSON.parse(data);
      
      if (user && pass) {
        this.$fieldbeat.authorize_as_basic(user , pass);
        this.$fieldbeat.post('/fleets/develop/create_fleet', this.json).then(response => {          
          if (response.code === 201) {

            this.pwd = response.json.password;
            this.handleFormSubmitted(response.json.fleet)
          }
          this.closeModal();
        })
      }
    },
    updateContent(content, form) {
      this.dynamicContent = content;
      this.form = form;
    },
    updateTitle(title) {
      this.dynamicTitle = title;
    },
    handleFormSubmitted(fleet) {
      setTimeout(()=>{
        this.dynamicTitle2 = 'Información nueva flota'
        this.enterpriseName = fleet
        this.showSecondModal = true
      },1)
    },
    closeSecondModal() {
      this.showSecondModal = false;
    },
  },
};
</script>
<style>
.less-margin{
  .modal.show .modal-dialog{
     margin-top: 36px !important;
  }
}
</style>
